import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import "../style.scss";
import "./style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { showRequestRequest } from "../../../store/requests/actions";

const RequestDetails = ({ intl: { messages }, show, close, requestId }) => {
    const lang = localStorage.getItem("lang") || "en";
    const { request } = useSelector((state) => state.requests);
    const dispatch = useDispatch();

    useEffect(() => {
        if (requestId) {
            dispatch(showRequestRequest(requestId));
        }
    }, [dispatch, requestId]);

    if (!request) return null

    return (
        <div className={`test-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="test-modal_container_content">
                    <CancelIcon onClick={close} className="test-modal_container_content_close" />
                <div className="test-modal_container_content_header">
                    <h4>{messages.patients.patient_requests.request_details}</h4>
                </div>
                <div className="test-modal_container_content_body">
                    <form>
                        <label htmlFor="date" style={{marginBottom: "10px", marginTop: "15px"}} >{messages.patients.patient_requests.date} : <span>{moment(request?.created_at).format("DD[.]MM[.]YYYY , HH:mm:ss")}</span></label>
                        <label htmlFor="message" style={{marginBottom: "10px", marginTop: "15px"}} >{messages.patients.patient_requests.message}</label>
                        <textarea style={{ marginTop: "10px" }}
                            id='message'
                            name="message"
                            value={request?.message_text}
                            readOnly={true}
                            rows={3}
                            ></textarea>
                        
                        <label htmlFor="status" style={{marginBottom: "10px", marginTop: "25px"}} >{messages.patients.patient_requests.status} : <span>{request?.request_status}</span></label>
                        <label htmlFor="stage" style={{marginBottom: "10px", marginTop: "15px"}} >{messages.patients.patient_requests.stage} : <span>{request?.stage_name}</span></label>
                        {
                            request?.stage === 4 && (
                                <>  
                                    <label htmlFor="cancel_reason" style={{marginBottom: "10px", marginTop: "15px"}} >{messages.patients.patient_requests.cancel_reason}</label>
                                    <textarea style={{ marginTop: "10px" }}
                                        id='cancel_reason'
                                        name="cancel_reason"
                                        value={request?.cancel_reason_message}
                                        readOnly={true}
                                        rows={3}
                                        ></textarea>
                                </>
                            )
                        }
                    </form>   
                </div>
            </div>
           
        </div>
    );
}
export default injectIntl(RequestDetails);
